import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Icon from 'react-fa';
import { request } from '../helpers/request';
import { getOrg, isAdmin } from '../helpers/access';
import { t } from '../helpers/translate';
import LoadingComponent from './common/LoadingComponent';
import ModalComponent from './common/ModalComponent';
import axios from 'axios';

let config = require('config');

class ResourceCentre extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      showModal: false,
      modalTitle: null,
      modalBody: null,
      display: this.intialDisplay() || 'resource',
      document_name: '',
      document_url: '',
      short_intro: '',
      logo_url: '',
      editDoc: null,
      deleteDocId: null,
      loading: false,
      is_french: false,
      image_url: '',
      agent_name: '',
      score: '',
    };
  }

  componentDidMount() {
    this.fetchDataIfNeeded();
    this.scrollToTheTop();
  }

  componentWillUnmount() {
    sessionStorage.removeItem('active_resource_display');
  }

  intialDisplay() {
    let initialDisplay = 'resource';

    if (this.props.location.state && this.props.location.state.display) {
      initialDisplay = this.props.location.state.display;
      sessionStorage.setItem('active_resource_display', initialDisplay);

      if (this.props.history) {
        const { display, ...remainingState } = this.props.location.state;

        this.props.history.replace({
          ...this.props.location,
          state: Object.keys(remainingState).length > 0 ? remainingState : undefined
        });
      }
    } else if (sessionStorage.getItem('active_resource_display')) {
      initialDisplay = sessionStorage.getItem('active_resource_display');
    }

    return initialDisplay;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.display !== prevState.display) {
      this.fetchDataIfNeeded();
    }
  }

  fetchDataIfNeeded = () => {
    const { display } = this.state;
    if (['product_insights', 'leaderboard', 'promos', 'dashboard_banner'].includes(display)) {
      this.getDocuments();
    }
  };

  getDocuments = () => {
    this.setState({ loading: true, loadingText: t('Loading') });

    request(this.resourceApiUrl(), 'GET', null, (responseData, status) => {
      if (status === 200) {
        this.setState({
          documents: responseData.resources || [],
          loading: false
        });
      } else {
        this.setState({ loading: false });
        this.showModal(t('Error'), responseData.messages.map((m, i) => <p key={i}>{m}</p>));
      }
    });
  };

  resourceApiUrl = () => {
    return `${config.default.api}/resourcecentre/${this.state.display}`;
  };

  showModal = (title, body, button = null, buttonAction = null) => {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: t(title),
      resetDataOnClose: true,
      modalOptionalButton: button ? t(button) : null,
      modalAction: buttonAction
    });
  };

  handleModalClose = () => {
    this.setState({
      showModal: false
    });
    this.fetchDataIfNeeded();
  };

  decodeTitle = (html) => {
    if (!html) return '';
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  getFilesArray() {
    const file = this.state.document_url;

    if (file && file.name) {
      return [{
        filename: file.name,
        status: 'Pending'
      }];
    }

    return [];
  }

  handleFileSelection = (event) => {
    const file = event.target.files && event.target.files[0];

    if (!file) {
      return;
    }

    this.setState({
      document_url: file,
      filesStatus: [{
        filename: file.name,
        status: 'Pending'
      }],
      errors: []
    });
  };

  handleLogoSelection = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.size > 1024 * 1024) {
        this.showModal(t('Error'), t('Logo image must be smaller than 1MB.'));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          logo_base64: reader.result,
          logo_file_name: file.name
        });
      };
      reader.readAsDataURL(file);
    }
  };

  addEditRowSubmit = (editDoc) => {
    if (this.state.processing) {
      return;
    }

    const isEdit = !!editDoc;
    const isDashboardBanner = this.state.display === 'dashboard_banner';
    const file = this.state.document_url;
    const isNewFileUpload = file && typeof file === 'object' && file.name;

    if (isDashboardBanner && !(this.state.image_url || (editDoc && editDoc.image_url))) {
      this.setState({ errors: [t('Please enter a banner image URL.')] });
      return;
    }

    if (editDoc && !isDashboardBanner) {
      const currentName = this.state.document_name;
      const originalName = editDoc.document_name;

      const currentIntro = this.state.short_intro;
      const originalIntro = editDoc.short_intro;

      const currentAgentName = this.state.agent_name;
      const originalAgentName = editDoc.agent_name;

      const currentScore = this.state.score;
      const originalScore = editDoc.score;

      const hasNameChanged = currentName !== originalName;
      const hasIntroChanged = currentIntro !== originalIntro;
      const hasFileChanged = isNewFileUpload;
      const hasLogoChanged = !!this.state.logo_base64;
      const hasAgentNameChanged = currentAgentName !== originalAgentName;
      const hasScoreChanged = currentScore !== originalScore;
      const leaderboard = this.state.display !== 'leaderboard' ? (!hasNameChanged && !hasIntroChanged && !hasFileChanged && !hasLogoChanged) : (!hasAgentNameChanged && !hasScoreChanged);

      if (leaderboard) {
        this.showModal(t('Success'), t('No changes were made.'));
        return;
      }
    }

    if (!isEdit && !isNewFileUpload && this.state.display !== 'leaderboard' && !isDashboardBanner) {
      this.setState({
        errors: [t('Please select a document to upload.')]
      });
      return;
    }

    const payload = {
      org: getOrg(),
      resource_type: this.state.display,
      document_data: {
        id: editDoc ? editDoc.id : '',
        image_url: this.state.image_url || (editDoc && editDoc.image_url) || '',
        document_name: this.state.document_name || (editDoc ? editDoc.document_name : ''),
        short_intro: this.state.short_intro || (editDoc ? editDoc.short_intro : ''),
        document_url: isNewFileUpload ? file.name : (editDoc ? editDoc.document_url : ''),
        logo_url: this.state.logo_url || (editDoc ? editDoc.logo_url : ''),
        is_french: this.state.is_french || (editDoc ? editDoc.is_french : false),
        agent_name: this.state.agent_name || (editDoc ? editDoc.agent_name : ''),
        score: this.state.score || (editDoc ? editDoc.score : '')
      }
    };

    this.setState({
      processing: true,
      loading: true,
      loadingText: isNewFileUpload ? t('Uploading') : t('Saving'),
      errors: [],
      filesStatus: isNewFileUpload ? [{ filename: file.name, status: 'Pending' }] : []
    });

    request(
      this.resourceApiUrl(),
      editDoc ? 'PUT' : 'POST',
      payload,
      function (response, status) {
        if (status === 200) {
          if (isNewFileUpload) {
            const presignedUrls = response.presigned_urls || (response.data && response.data.presigned_urls) || [];
            const signedUrl = presignedUrls[0];

            if (!signedUrl) {
              this.setState({ processing: false, loading: false });
              this.showModal(t('Error'), t('There was an error generating the upload link.'));
              return;
            }

            this.uploadToS3(file, signedUrl);
          } else {
            this.setState({ processing: false, loading: false, agent_name: '', score: '', logo_url: '', document_name: '', short_intro: '', is_french: false, document_url: '', image_url: '', filesStatus: [] });
            this.showModal(t('Success'), t('Your resource has been updated successfully.'));
          }
        } else {
          this.setState({ processing: false, loading: false });
          const messages = response.messages || (response.data && response.data.messages) || [response.message || 'An error occurred'];

          this.showModal(
            t('Error'),
            messages.map((m, i) => <p key={i}>{m.message || m}</p>)
          );
        }
      }.bind(this),
      {
        'Content-Type': 'application/json'
      },
      true
    );
  };

  uploadToS3(file, signedUrl) {
    axios.put(signedUrl, file, {
      headers: {
        'Content-Type': file.type || 'application/octet-stream'
      }
    })
      .then(function () {
        this.completeResourceUpload(file);
      }.bind(this))
  }

  completeResourceUpload(file) {
    this.setState(
      {
        processing: false,
        loading: false,
        document_url: null,
        filesStatus: [{
          filename: file.name,
          status: 'Complete'
        }]
      },
      function () {
        if (this.documentFileInput) {
          this.documentFileInput.value = '';
        }

        this.showModal(
          t('Success'),
          t('Your resource has been uploaded successfully.')
        );
      }.bind(this)
    );
  }

  handleViewFile = (doc) => {
    const tempLinkUrl = `${config.default.api}/downloadResource/${doc.id}`;

    request(tempLinkUrl, 'GET', null, function (res, status) {
      if (status === 200) {
        const signedUrl = res.signed_url || res.signedUrl || res.url ||
          (
            res.data &&
            (res.data.signed_url || res.data.signedUrl)
          );

        if (signedUrl) {
          window.open(signedUrl, '_blank');
        } else {
          this.showModal(
            t('Error'), t('Invalid link returned.'));
        }

        return;
      }

      this.showModal(t('Error'), t('Could not generate view link for this document.'));
    }.bind(this)
    );
  };

  deleteRow = () => {
    this.handleModalClose();
    this.setState({ loading: true, loadingText: t('Deleting') });

    const payload = { row: { id: this.state.deleteDocId } };
    request(this.resourceApiUrl(), 'DELETE', payload, (responseData, status) => {
      if (status === 200) {
        this.setState({ loading: false });
        this.showModal(t('Success'), t('Your resource has been deleted'));
      } else {
        this.setState({ loading: false });
        this.showModal(t('Error'), responseData.messages.map((m, i) => <p key={i}>{m}</p>));
      }
    });
  };

  handleAddItem = (doc = null) => {
    this.setState({
      editDoc: doc,
      image_url: doc ? doc.image_url : '',
    });

    this.showModal(
      t(doc ? 'Edit Item' : 'Add Item'),
      this.showAddEditModal(doc),
      t(doc ? 'Update' : 'Save'),
      () => this.addEditRowSubmit(doc)
    );
  };

  handleDeleteItem = (id) => {
    this.setState({ deleteDocId: id });
    const deleteWarning = (
      <div className='text-center'>
        <div className="mobile-top-padding mb-3">
          <Icon name="exclamation-triangle" size="2x" className="text-warning" />
        </div>
        <h4>{t('Are you sure you want to delete this file?')}</h4>
      </div>
    );
    this.showModal(t('Delete File'), deleteWarning, t('Confirm'), this.deleteRow);
  };

  handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    const setValue = name === 'is_french' ? checked : value;
    this.setState({ [name]: setValue });
  };

  scrollToTheTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  handleDisplayChange = (newDisplay) => {
    this.setState({ display: newDisplay });
    sessionStorage.setItem('active_resource_display', newDisplay);
  }

  toggleSelection = (resource) => {
    if (resource.extLink && resource.extLink.length > 0) {
      return window.open(resource.extLink, '_blank');
    }

    this.handleDisplayChange(resource.type);
  };

  handleReturnButton = () => {
    const { display } = this.state;
    if (['product_insights', 'leaderboard', 'promos', 'dashboard_banner'].includes(display)) {
      this.handleDisplayChange('training');
    } else {
      this.handleDisplayChange('resource');
    }
  };

  showAddEditModal = (editDoc) => {
    const isAddingNew = !editDoc;
    const leaderboardDisplay = this.state.display === 'leaderboard';
    const showAsterisk = isAddingNew && <span className="text-danger">*</span>;

    if (this.state.display === 'dashboard_banner') {
      return (
        <div className="p-2">
          <div className="form-group mb-0">
            <label className="text-uppercase">{t('Banner Image URL')}</label>
            <input type="url" defaultValue={editDoc ? editDoc.image_url : ''} name="image_url" onChange={this.handleInputChange} className="form-control shadow-sm" placeholder="https://" />
            <small className="text-muted">{t('Paste the URL of the banner image.')}</small>
          </div>
        </div>
      );
    }

    return !leaderboardDisplay ? (
      <div className="p-2">
        <Row className="mb-3">
          <Col md={6} sm={6}>
            <label className="text-uppercase">{t('Uploading a french document?')}</label>
          </Col>
          <Col className="mt-3" md={6} sm={6}>
            <input type="checkbox" name="is_french" value={editDoc ? editDoc.is_french : this.state.is_french} checked={editDoc && editDoc.is_french} disabled={editDoc} onChange={this.handleInputChange} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6} sm={12}>
            <div className="form-group mb-md-0">
              <label className="text-uppercase resource-form-label">{t('Title / Titre')} {showAsterisk}</label>
              <input type="text" defaultValue={editDoc ? editDoc.document_name : ''} name="document_name" onChange={this.handleInputChange} className="form-control shadow-sm" />
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className="form-group mb-0">
              <label className="text-uppercase resource-form-label">{t('Document File / Fichier document')} {showAsterisk}</label>
              <input
                type="file"
                name="document_url"
                accept=".pdf,.csv,.doc,.docx,.xls,.xlsx"
                ref={function (input) {
                  this.documentFileInput = input;
                }.bind(this)}
                onChange={this.handleFileSelection}
              />
              <small className="text-muted">{isAddingNew ? t('Upload file OR paste URL.') : t('Upload new file to replace existing.')}</small>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} sm={12}>
            <div className="form-group mb-sm-3 mb-md-0">
              <label className="text-uppercase resource-form-label">{t('Logo URL / URL du logo')} {showAsterisk}</label>
              <input type="text" defaultValue={editDoc ? editDoc.logo_url : ''} name="logo_url" onChange={this.handleInputChange} className="form-control shadow-sm mb-2" placeholder="https://" />
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className="form-group mb-0">
              <label className="text-uppercase resource-form-label">{t('Short Description / Description courte')} {showAsterisk}</label>
              <textarea defaultValue={editDoc ? editDoc.short_intro : ''} name="short_intro" onChange={this.handleInputChange} className="form-control shadow-sm" rows="4" style={{ resize: 'vertical' }} />
            </div>
          </Col>
        </Row>
      </div>
    ) :
      <div className="p-2">
        <Row>
          <Col md={6} sm={12}>
            <div className="form-group mb-0">
              <label className="text-uppercase">{t('Agent Name / Nom de l’agent')} {showAsterisk}</label>
              <input type="text" defaultValue={editDoc ? editDoc.agent_name : ''} name="agent_name" onChange={this.handleInputChange} className="form-control shadow-sm" />
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className="form-group mb-0">
              <label className="text-uppercase">{t('Score / Score')} {showAsterisk}</label>
              <input type="number" defaultValue={editDoc ? editDoc.score : ''} name="score" onChange={this.handleInputChange} className="form-control shadow-sm" />
            </div>
          </Col>
        </Row>
      </div>;
  };

  renderNavigationTile = (item, index) => {
    const colSpan = item.type === 'governmentresources' ? 12 : 6;
    return (
      <Col md={colSpan} key={index} className="mb-4">
        <div className="resource-content p-4">
          <Row className="align-items-center">
            <Col md={3} className="text-center mt-4">
              <img className="img-resource" src={item.logo} alt={item.title} />
            </Col>
            <Col md={9} className="sub-resource text-container">
              <h3 className="resources-tile-title mt-0" style={{ WebkitBoxOrient: 'vertical' }}>{t(item.title)}</h3>
              <p className="resources-tile-subtext text-muted" style={{ WebkitBoxOrient: 'vertical' }}>{t(item.shortIntro)}</p>
              <button
                className="btn button-secondary primary-btn-color mt-2"
                onClick={() => this.toggleSelection(item)}
              >
                {t('Read More')}
              </button>
            </Col>
          </Row>
        </div>
      </Col>
    )
  };

  renderManageableItem = (item, index) => {
    const parsedData = this.parseDocumentData(item);
    const docWithId = { ...parsedData, id: item.id };
    return (
      <Col md={12} key={index} className="mb-3">
        <div className="resource-content manageable-resource p-3">
          <Row className="align-items-center">
            <Col md={2} sm={3} className="text-center">
              <img className="img-blog" src={parsedData.logo_url} alt="Logo" />
            </Col>
            <Col md={7} sm={9} className="sub-article text-container">
              <h4 className="mt-0">{this.decodeTitle(parsedData.document_name)}</h4>
              <p className="text-muted mb-0">{t(parsedData.short_intro)}</p>
            </Col>
            <Col md={3} sm={12} className="action-buttons text-right mt-3 mt-md-0">
              {isAdmin('ingle') &&
                <div className="d-flex justify-content-end mb-2">
                  <button className="btn btn-default mr-2" onClick={() => this.handleAddItem(docWithId)}>
                    <Icon name="pencil" />
                  </button>
                  <button className="btn btn-danger ml-2 mr-2" onClick={() => this.handleDeleteItem(item.id)}>
                    <Icon name="trash" />
                  </button>
                </div>
              }
              <button className="btn button-secondary primary-btn-color w-100 mt-2" onClick={() => this.handleViewFile(docWithId)}>
                {t(this.state.display === 'promos' ? 'View Promotion' : 'View File')}
              </button>
            </Col>
          </Row>
        </div>
      </Col>
    );
  };

  renderDashboardBanner = (item) => {
    const data = this.parseDocumentData(item);
    return (
      <div className="resource-content manageable-resource p-3 mb-3">
        <Col md={9} sm={9} className="sub-article text-container">
          <img src={data.image_url} alt={t('Dashboard banner')} className="resource-banner-preview" />
        </Col>
        <Col md={3} sm={12} className="action-buttons text-right mt-8">
          {isAdmin('ingle') &&
            <div className="d-flex justify-content-end mb-2 mt-8">
              <button className="btn btn-default mr-2" onClick={() => this.handleAddItem({ ...data, id: item.id })}>
                <Icon name="pencil" />
              </button>
              <button className="btn btn-danger ml-2 mr-2" onClick={() => this.handleDeleteItem(item.id)}>
                <Icon name="trash" />
              </button>
            </div>
          }
        </Col>
      </div>
    );
  };

  parseDocumentData(agent) {
    const parsedData = typeof agent.document_data === 'string' ? JSON.parse(agent.document_data) : (agent.document_data || {});
    return parsedData;
  }

  renderLeaderboardView = (agents) => {
    const sortedAgents = [...agents].sort((a, b) => {
      this.parseDocumentData(a);
      const scoreA = this.parseDocumentData(a).score;
      const scoreB = this.parseDocumentData(b).score;
      return scoreB - scoreA;
    });

    return (
      <Col md={12}>
        <div className="leaderboard-container mt-4">
          {sortedAgents.map((agent, index) => {
            const isTop3 = index < 3;
            const rankClass = isTop3 ? `rank-${index + 1}` : 'standard-rank';
            const parsedData = this.parseDocumentData(agent);
            const docWithId = { ...parsedData, id: agent.id };

            let RankIcon = null;
            if (index === 0) RankIcon = <Icon name="trophy" className="medal gold-medal" />;
            else if (index === 1) RankIcon = <Icon name="trophy" className="medal silver-medal" />;
            else if (index === 2) RankIcon = <Icon name="trophy" className="medal bronze-medal" />;
            else RankIcon = <span className="rank-number">#{index + 1}</span>;

            return (
              <div className={`leaderboard-row ${rankClass} p-3 mb-2`} key={parsedData.id || index}>
                <Col xs={2} className="lb-left lb-rank-badge">{RankIcon}</Col>
                <Col xs={7}>
                  <h4 className="lb-name mb-0">{parsedData.agent_name || 'Agent Name'}</h4>
                </Col>
                <Col xs={3} className="lb-right">
                  <div className="lb-score text-right mb-2">
                    <span className="score-value">{parsedData.score ? parsedData.score.toLocaleString() : 0}</span>
                    <span className="score-label">pts</span>
                  </div>
                  {isAdmin('ingle') &&
                    <div className="lb-actions">
                      <button className="btn btn-xs btn-default mr-2" onClick={() => this.handleAddItem(docWithId)}><Icon name="pencil" /></button>
                      <button className="btn btn-xs btn-danger ml-2" onClick={() => this.handleDeleteItem(agent.id)}><Icon name="trash" /></button>
                    </div>
                  }
                </Col>
              </div>
            );
          })}
        </div>
      </Col>
    );
  };

  renderPageTitles = () => {
    const { display } = this.state;
    const configData = config.default.resource_centre;

    let title = '';
    let info = '';

    if (configData.pageInfo && configData.pageInfo[display]) {
      title = configData.pageInfo[display].title;
      info = configData.pageInfo[display].info;
    } else {
      title = configData.training[display].title;
      info = configData.training[display].shortIntro;
    }

    return (
      <Col md={12} className="text-center mb-4">
        <h2 className="page-title">{t(title)}</h2>
        {info && <h5 className="page-subtitle text-muted">{t(info)}</h5>}
      </Col>
    );
  };

  renderArticles = () => {
    if (this.state.loading) return null;

    const { display, documents } = this.state;
    const configData = config.default.resource_centre;

    let articleList = [];
    let renderMethod = null;
    let isCustomLayout = false;

    if (display === 'resource') {
      articleList = Object.values(configData.resources);
      renderMethod = this.renderNavigationTile;
    }

    else if (display === 'training') {
      articleList = Object.values(configData.training).filter((item) => item.type !== 'dashboard_banner' || isAdmin('ingle'));
      renderMethod = this.renderNavigationTile;
    }

    else if (display === 'government') {
      articleList = configData.government || [];
      renderMethod = this.renderNavigationTile;
    }

    else if (display === 'dashboard_banner') {
      articleList = Array.isArray(documents) ? documents : [];
      renderMethod = this.renderDashboardBanner;
    }

    else if (['product_insights', 'promos'].includes(display)) {
      articleList = Array.isArray(documents) ? documents : [];
      renderMethod = this.renderManageableItem;
    }

    else if (display === 'leaderboard') {
      articleList = Array.isArray(documents) ? documents : [];
      isCustomLayout = true;
    }

    return (
      <div>
        <Row>
          {this.renderPageTitles()}
        </Row>
        {display !== 'resource' && (
          <Row className="mb-4">
            <Col md={12} className="d-flex justify-content-between align-items-center">
              <button className="btn button-secondary ml-6" onClick={this.handleReturnButton}>
                <Icon name="chevron-left" /> {t("Return to Previous Page")}
              </button>
            </Col>
          </Row>
        )}
        <Row>
          {articleList.length > 0 ? (
            isCustomLayout ? this.renderLeaderboardView(articleList) : articleList.map((item, i) => renderMethod(item, i))
          ) : (
            <Col md={12} className="text-center mt-5 mb-5">
              <div className="p-5 bg-light rounded text-muted" style={{ border: '1px dashed #ccc' }}>
                <Icon name="folder-open-o" size="3x" className="mb-3" />
                <h4>{t("No items found")}</h4>
                <p>{t("There are currently no items available in this section.")}</p>
              </div>
            </Col>
          )}
        </Row>
        {isAdmin('ingle') &&
          <Row className="mb-4">
            <Col md={12} className="text-center mt-5 mb-5">
              {['product_insights', 'leaderboard', 'promos'].includes(display) && (
                <button className="btn button-secondary primary-btn-color ml-8 mt-2" onClick={() => this.handleAddItem(null)}>
                  <Icon name="plus" /> {display === 'leaderboard' ? t("Add Agent") : t("Add New File")}
                </button>
              )}
              {display === 'dashboard_banner' && documents.length === 0 && (
                <button className="btn button-secondary primary-btn-color ml-8 mt-2" onClick={() => this.handleAddItem(null)}>
                  <Icon name="plus" /> {t('Add Banner')}
                </button>
              )}
            </Col>
          </Row>
        }
      </div>
    );
  };

  render() {
    return (
      <div className="container mt-4 mb-5">
        {this.renderArticles()}
        <LoadingComponent show={this.state.loading} text="Loading" />

        <ModalComponent
          title={this.state.modalTitle}
          body={this.state.modalBody}
          onClose={this.handleModalClose}
          show={this.state.showModal}
          onSubmit={this.state.modalAction}
          resetDataOnClose={this.state.resetDataOnClose}
          buttonName={this.state.modalOptionalButton}
        />
      </div>
    );
  }
}

ResourceCentre.displayName = 'Resource Centre';
export default ResourceCentre;



// WEBPACK FOOTER //
// ./src/components/ResourceCentre.js